module.exports = __webpack_public_path__ + "static/media/toyota-headset.a7562d12.svg";